import { Navigate, useSearchParams } from 'react-router-dom';
import LegacyPersonalCoveragePage from './LegacyPersonalCoverage';
import QuotePersonalization from './QuotePersonalization';

export default function PersonalCoveragePage() {
  const [searchParams] = useSearchParams();
  const quoteHash = searchParams.get('quote');
  const legacy = searchParams.get('legacy') === 'true';

  if (legacy) {
    return <LegacyPersonalCoveragePage />;
  }

  if (!quoteHash) {
    return <Navigate replace to={{ pathname: '/', search: searchParams.toString() }} />;
  }

  return <QuotePersonalization variant="journey" />;
}
